module.exports = __webpack_public_path__ + "img/image12.fbf66f11.jpg";